<div class="loading">
    <div class="loading-position">
        <mat-progress-spinner aria-label="Loading" [mode]="'indeterminate'"></mat-progress-spinner>
        <span>{{ message() }}</span>
    </div>
</div>
